import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';

import MobileNav from './MobileNav';
import DarkModeToggle from './DarkModeToggle';

import { bpMaxXS, bpMaxXXXS } from '../utils/breakpoints';

// import { InternalLink } from './StyledComponents/Links';

const StyledHeader = styled.header`
	a.logo {
		font-family: 'Russo One';
		color: var(--color-text);
	}

	/* .toggle-container {
		width: 29px;
		margin-right: ${(props) =>
		props.isHome ? '-20px' : '-30px'};
	} */

	${bpMaxXS} {
		.toggle-container {
			right: 80px;
			position: absolute;
		}
	}

	${bpMaxXXXS} {
		h1 {
			padding: 0.2rem 0;
			font-size: 1.25rem;
		}

		.toggle-container {
			right: 65px;
			position: absolute;
		}
	}
`;

export default function Header({ data, location }) {
	// console.log('LOCATION', location);
	const baseClass = 'font-bold leading-tight';
	const isHome = location.pathname === '/';
	const logoContainerClass = isHome
		? 'text-2xl sm:text-4xl'
		: 'text-xl sm:text-3xl py-1';

	return (
		<StyledHeader isHome={isHome} className="flex justify-between">
			<h1 className={`${baseClass} ${logoContainerClass}`}>
				<Link to="/" className="logo">
					<span className="first-child">CUNNING</span>
					<span className="second-child">KRUGER</span>
				</Link>
			</h1>
			<div className="toggle-container relative">
				<DarkModeToggle />
			</div>
			<MobileNav data={data} location={location} />
		</StyledHeader>
	);
}
